import type { TourConfig } from '../../types/tour.types'

// Lead Enrichment — column-mapping modal. Shares the LeadEnrichment route with the
// dashboard tour; the `condition` (the mapping step being on screen) decides which
// is active. Auto-starts the moment the modal appears (engine watches the DOM).
const leadEnrichmentMappingTour: TourConfig = {
  id: 'lead-enrichment-mapping',
  title: 'Map your columns',
  module: 'Enrichment',
  routeName: 'LeadEnrichment',
  order: 7,
  autoStart: true,
  featureFlag: 'enableLeadEnrichment',
  condition: () => !!document.querySelector('.scm-root'),
  steps: [
    {
      id: 'intro',
      target: '.scm-root',
      placement: 'auto',
      title: 'Match your file to TAMI',
      body: 'To enrich accurately, TAMI needs to know which column in your file is which. We **auto-match** everything we recognise — you just confirm and fill in anything we missed.',
    },
    {
      id: 'fields',
      target: '.scm-field-list',
      placement: 'end',
      title: 'One TAMI field per row',
      body: 'Each row is a TAMI field. A **green check** means we matched it to a column in your file automatically. Required fields are marked with a red **\\***.',
    },
    {
      id: 'select',
      target: '.scm-field-select',
      placement: 'start',
      optional: true,
      title: 'Fix anything we missed',
      body: 'Where a field isn\'t matched, pick the right column from your file in this dropdown. Make sure every **required** field has a column before you continue.',
    },
    {
      id: 'next',
      target: '[data-tour="scm-next"]',
      placement: 'top',
      optional: true,
      title: 'Continue when it\'s all mapped',
      body: 'Once your required fields are mapped, click **Next** to run the enrichment. You can always come back and adjust the mapping if something looks off.',
    },
  ],
}

export default leadEnrichmentMappingTour
